// 部材選択コンポーネント

// React 18以降はJSXの自動変換によりReactインポートは不要
import { MATERIAL_OPTIONS } from '../types';

interface MaterialSelectorProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  touched?: boolean;
}

export function MaterialSelector({
  value,
  onChange,
  error,
  touched,
}: MaterialSelectorProps) {
  const showError = error && touched;

  return (
    <div className="form-group">
      <label htmlFor="material-select" className="form-label">
        部材名
        <span className="text-red-600 ml-1" aria-label="必須">*</span>
      </label>
      
      <select
        id="material-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`input-field ${showError ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}`}
        aria-invalid={showError ? 'true' : 'false'}
        aria-describedby={showError ? 'material-error' : undefined}
      >
        <option value="" disabled>
          部材を選択してください
        </option>
        {MATERIAL_OPTIONS.map((material) => (
          <option key={material} value={material}>
            {material}
          </option>
        ))}
      </select>

      {showError && (
        <div id="material-error" className="form-error" role="alert">
          {error}
        </div>
      )}
    </div>
  );
}